import type { ChangeEventHandler, FocusEventHandler } from 'react'
import clsx from 'clsx'
import styled from 'styled-components'
import focusStyle from 'styles/utils/focusStyle'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import { BodyTextMedium } from 'LuxKit/Typography/BodyText'
import { tripPlannerNavigationRowStyle } from './tripPlannerNavigationRowStyle'

const SEARCH_ICON = <LineSearchIcon />

// The design shows search as a borderless row matching New chat, which LuxKit's bordered TextInput can't be styled into.
const Row = styled.label`
  ${tripPlannerNavigationRowStyle}
  cursor: text;

  &.selected {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackgroundAlt};
  }

  &:has(:focus-visible) {
    ${focusStyle}
  }
`

const Input = styled.input`
  ${BodyTextMedium}
  flex: 1;
  min-inline-size: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  outline: none;
  appearance: none;

  &::placeholder {
    color: inherit;
    opacity: 1;
  }

  &:focus::placeholder {
    color: ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  }
`

interface Props {
  label: string
  value: string
  selected: boolean
  onChange: ChangeEventHandler<HTMLInputElement>
  onFocus: FocusEventHandler<HTMLInputElement>
  onBlur: FocusEventHandler<HTMLInputElement>
}

function TripPlannerSearchChatsRow({ label, value, selected, onChange, onFocus, onBlur }: Props) {
  return (
    <Row className={clsx({ selected })}>
      {SEARCH_ICON}
      <Input
        type="search"
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={label}
        aria-label={label}
        autoComplete="off"
      />
    </Row>
  )
}

export default TripPlannerSearchChatsRow
